let UserFactory = function ($rootScope, UserService, Auth) {
  this.User = {}
  this.acl = {}
  this.$rootScope = $rootScope
  this.UserService = UserService
  this.Auth = Auth
  this.prevState = {}
  let setACL = (acl) => {
    let navbar = {}
    let setting = {}
    let tntBilling = {}
    let tntControl = {}
    let branchMgmt = {}
    let _reporting = {};
    for (let [key1, permissions] of Object.entries(acl)) {
      if (key1.includes('setting-')) {
        setting[key1] = permissions
      } else if (key1.includes('tnt_billing_')) {
        tntBilling[key1] = permissions
      } else if (key1.includes('tnt_control_')) {
        tntControl[key1] = permissions
      } else if (key1.includes('reporting_')){
        _reporting[key1] = permissions;
      } else {
        navbar[key1] = permissions
      }
    }

    acl['navbar'] = navbar
    acl['setting'] = setting
    acl['tntBilling'] = tntBilling
    acl['tntControl'] = tntControl
    acl['_reporting'] = _reporting;
    this.acl = acl;
  }

  let getACL = (key) => {
    if (key in this.acl) {
      return this.acl[key];
    } else {
      return {}
    }
  }

  let hasACL = () => {
    return Object.entries(this.acl).length
  }

  let setUser = (user) => {
    $rootScope.$broadcast('userChanged', user)
    this.user = user
  };

  let getUser = () => {
    return this.user
  };

  let isSignedIn = () => {
    return !!this.user.email || this.user.customerUser
  };

  let clearUser = () => {
    setUser(null)
  }

  let hasUser = () => {
    return !angular.equals(this.user, {})
  }

  let isAccessible = (key) => {
    let resource = key.split('.')[0]
    let permissions = key.split('.')[1].split(',')

    if (this.acl[resource]) {
      return permissions.some(p => this.acl[resource].indexOf(p.trim()) >= 0)
    } else {
      return false
    }
  }
  let getPrevState = () => this.prevState
  let setPrevState = (state) => {
    this.prevState = state
  }
  return {
    setUser,
    getUser,
    isSignedIn,
    clearUser,
    hasUser,
    getACL,
    setACL,
    hasACL,
    isAccessible,
    getPrevState,
    setPrevState
  };
};

UserFactory.$inject = ['$rootScope', 'UserService', 'Auth'];

export default UserFactory;


// WEBPACK FOOTER //
// ./client/app/common/user/user.factory.js